import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JsonConverter } from '@app-core/services/utility/json-conveter';
import { ReviewManageInfo } from '@app-units/models/review/review-manage-info';
import { Observable } from 'rxjs';

@Injectable()
export class ReviewManageInfoHttpService {
  constructor(private http: HttpClient) {}

  fetchItems(id: string): Observable<app.response<ReviewManageInfo>> {
    return this.http
      .get(this.getUrl(id))
      .pipe(map(JsonConverter.toReviewManageInfo));
  }

  saveItem(item: ReviewManageInfo): Observable<app.response<ReviewManageInfo>> {
    return this.http
      .put(this.getUrl(String(item.id)), item)
      .pipe(map(JsonConverter.toReviewManageInfo));
  }

  private getUrl(id: string) {
    return `/reviews/${id}/manage_info`;
  }
}
